import { makeApiRequest, proxyUrl } from './_index'

export async function getS3FolderContents(folderName) {
    const encodedFolderName = encodeURIComponent(folderName)
    const url = `${proxyUrl}/api/s3/folders/get-list/${encodedFolderName}`
    const options = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    }

    return makeApiRequest(url, options)
}

export async function uploadFileToS3(s3Folder, file, fileName) {
    const fileType = file.type
    const urlRes = await fetch(
        `${proxyUrl}/api/s3/generate-presigned-url?fileName=${encodeURIComponent(s3Folder + '/' + fileName)}&fileType=${encodeURIComponent(fileType)}`
    )
    if (!urlRes.ok) throw new Error('Failed to get presigned URL')
    const { url } = await urlRes.json()
    console.log(url)

    const uploadRes = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': fileType
        },
        body: file
    })

    if (!uploadRes.ok) throw new Error('Failed to upload file to S3')

    return s3Folder + '/' + fileName
}